import React, { useEffect, useState } from "react";
// theme as @bit-design/reactTheme;
import { ConfigProvider } from "@bit-design/react";
import { ThemeProvider as Provider } from "styled-components";
import GlobalStyle from "./globalStyle";
import DarkTheme from "./themes/dark";
import WhiteTheme from "./themes/white";
import { useRecoilValue } from "recoil";
import { ThemeSelector, LocaleSelector } from "store/data/Base";
import { BitDesignLocaleMap } from "constants/base";
import "./index.less";
// import locale_en from '@bit-design/react/locale/en_US'
import useDirection from "hooks/useDirection";

const Theme = {
  [DarkTheme.theme]: DarkTheme,
  [WhiteTheme.theme]: WhiteTheme,
  dark: DarkTheme,
  light: WhiteTheme,
};

const dayjsLocaleMap = {
  "zh-CN": "zh-cn",
  "zh-TW": "zh-tw",
  pt_PT: "pt",
  "en-GB": "en",
  "en-PH": "en",
  "en-IN": "en",
  "en-ZA": "en",
  "pt-PT": "pt",
  "es-ES": "es",
};
// copy 自统一账户 menndy.xiang 的代码
const ThemeProvider = (props: any) => {
  const theme = useRecoilValue(ThemeSelector);
  const currentLocale = useRecoilValue(LocaleSelector);
  const [bitDesignLocal, setBitDesignLocal] = useState("en_US");

  useEffect(() => {
    Promise.all([
      // import(`@bit-design/react/locale/${BitDesignLocaleMap[currentLocale]}.js`),
      import(
        `dayjs/locale/${dayjsLocaleMap[currentLocale] || currentLocale}.js`
      ),
    ])
      .then(([bitDesignLocal]) => {
        setBitDesignLocal(bitDesignLocal.default);
      })
      .catch(() => {
        setBitDesignLocal("en_US");
      });
  }, [currentLocale]);

  const { direction } = useDirection();
  return (
    <ConfigProvider
      direction={direction}
      // theme={{
      //     algorithm:
      //         theme in Theme && (theme === 'black' || theme === 'dark')
      //             ? @bit-design/reactTheme.darkAlgorithm
      //             : @bit-design/reactTheme.defaultAlgorithm
      // }}
      locale={bitDesignLocal}
    >
      <Provider theme={theme in Theme ? Theme[theme] : Theme[DarkTheme.theme]}>
        {props.children}
        <GlobalStyle />
      </Provider>
    </ConfigProvider>
  );
};

export default ThemeProvider;
